/**
 * app.js
 * @authors Tommy (tao@winjoyit.com)
 * @date    2024-02-28 15:11:54
 * @version $Id$
 */
const conf = {
	appName: '云展商城商户管理系统',
	upAction: '/api/Upload',
}
export default conf